import React from 'react'

import { setIsFailedToLoadProjectModalOpen } from '../../store/ui/uiSlice'
import Modal from '../Modal/Modal'
import Heading from '../Heading/Heading'

import * as commonStyles from '../styles'
import * as styles from './styles'
import { loadDefaultProject } from '../../helpers/loadDefaultProject'
import { useAppDispatch, useAppSelector } from '../../hooks'

const Styled = {
  ...commonStyles,
  ...styles,
}

const FailedToLoadProjectModal: React.FC = () => {
  const { isFailedToLoadProjectModalOpen: isOpen } = useAppSelector((state) => state.ui) || {}
  const { content } = useAppSelector((state) => state.init) || {}
  const dispatch = useAppDispatch()

  const closeModal = (): void => {
    loadDefaultProject()
    dispatch(setIsFailedToLoadProjectModalOpen(false))
  }

  return (
    <Modal isOpen={isOpen} onRequestClose={closeModal} contentLabel={content.modals.failedToLoadProject.title}>
      <Styled.ModalBackPrompt>
        <Heading level={2}>{content.modals.failedToLoadProject.title}</Heading>
        <p>{content.modals.failedToLoadProject.information}</p>
        <Styled.Button className="button-primary" onClick={closeModal}>
          {content.modals.failedToLoadProject.ok}
        </Styled.Button>
      </Styled.ModalBackPrompt>
    </Modal>
  )
}

export default FailedToLoadProjectModal
